import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { customAlert } from "../../utils/alert";
import { HTTPURL } from "../../constant/Matcher";
export const login = createAsyncThunk(
    "auth/login",
    async (formData, thunkAPI) => {
     
        try {
            let config = {
                method: 'Post',
                url: `${HTTPURL}api/login`,
                headers: {
                    "Content-Type": "application/json",
                },
                data:formData
            };
            const res = await axios.request(config);
            if (res?.data?.status===true) {
                var now = new Date().getTime();
                localStorage.setItem('setupTime', now.toString());
                customAlert(res?.data?.message,'success');
            } 
            else {
                // customAlert(res?.data?.message);
            }
            return res.data;
        } catch (error) {
            customAlert(error?.response?.data? error?.response?.data?.message : error?.message);
        }
    }
);

